<template>
    <span class="label bg-green" v-if="unreadNotificationsCountLocal > 0">{{
        unreadNotificationsCountLocal
    }}</span>
</template>

<script>
import { EventBus } from "../../eventBus";
export default {
    props: ["unreadNotificationsCount"],
    data: function () {
        return {
            unreadNotificationsCountLocal: null,
        };
    },
    mounted() {
        this.unreadNotificationsCountLocal = this.unreadNotificationsCount;
        EventBus.on(
            "notificationRead",
            (unreadNotificationsCount, notificationId, infoMessage) => {
                this.setUnreadNotifications(unreadNotificationsCount);
            }
        );
    },
    methods: {
        setUnreadNotifications(unreadNotificationsCountLocal) {
            this.unreadNotificationsCountLocal = unreadNotificationsCountLocal;
        },
    },
};
</script>
